import React, { useEffect, useState } from "react";

import {
  Modal,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextareaAutosize,
} from "@mui/material";
import stateList from "../../../data/states.json";

const EditSchool = ({ open, onClose, rowData, onUpdate }) => {
  const [editData, setEditData] = useState(rowData);
  //   const [selectedFile, setSelectedFile] = useState(null);
  const [viewImage, setViewImage] = useState(rowData.image);
  const [cityList, setCityList] = useState([]);
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
    if (name === "state") {
      const selectedState = stateList.states.find(
        (s) => s.state_code === value
      );
      setCityList(selectedState ? selectedState.cities : []);
      setEditData((prev) => ({ ...prev, city: "" })); // Reset city selection
    }
  };

  //   const handleFileChange = (e) => {
  //     const file = e.target.files[0];
  //     setSelectedFile(URL.createObjectURL(file));
  //     setEditData((prev) => ({ ...prev, image: file }));
  //   };
  useEffect(() => {
    setEditData(rowData || {});

    // If rowData has a state, set the corresponding city list
    if (rowData?.state) {
      const selectedState = stateList.states.find(
        (s) => s.state_code === rowData.state
      );
      setCityList(selectedState ? selectedState.cities : []);
    } else {
      setCityList([]); // Reset city list if no state is selected
    }

  }, [rowData]);

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "60%",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>Edit Data</h2>

        <img
          src={viewImage}
          alt="Preview"
          style={{
            width: "100px",
            height: "100px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />

        <TextField
          label="Name"
          name="name"
          value={editData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>School Type</InputLabel>
          <Select
            name="school_type"
            value={editData.school_type}
            onChange={handleChange}
          >
            <MenuItem value="Government">Government</MenuItem>
            <MenuItem value="Private">Private</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Total Students"
          name="total_original_students"
          type="number"
          value={editData.total_original_students}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <FormControl component="fieldset" margin="normal">
          <label>Is Deleted?</label>
          <RadioGroup
            row
            name="is_deleted"
            value={editData.is_deleted === true ? "true" : "false"}
            onChange={(event) =>
              handleChange({
                target: {
                  name: "is_deleted",
                  value: event.target.value === "true",
                },
              })
            }
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>

        <TextareaAutosize
          minRows={3}
          placeholder="Address"
          name="address"
          value={editData.address}
          onChange={handleChange}
          style={{ width: "100%", marginBottom: "10px", padding: "10px" }}
        />

        <TextField
          label="Email"
          name="email"
          type="email"
          value={editData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Phone"
          name="phone"
          type="tel"
          value={editData.phone}
          onChange={handleChange}
          fullWidth
          margin="normal"
          inputProps={{ maxLength: 10 }}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>State</InputLabel>
          <Select name="state" value={editData.state} onChange={handleChange}>
            {stateList.states
              ?.sort((a, b) => a.name.localeCompare(b.name))
              ?.map((state) => (
                <MenuItem key={state.name} value={state.state_code}>
                  {state.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>City</InputLabel>
          <Select name="city" value={editData.city} onChange={handleChange}>
            {cityList.map((city) => (
              <MenuItem key={city} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Pincode"
          name="pincode"
          type="number"
          value={editData.pincode}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Admin Name"
          name="user_name"
          value={editData.user_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        {/* <FormControl fullWidth margin="normal">
          <InputLabel>Coordinator Designation</InputLabel>
          <Select
            name="coordinator_designation"
            value={editData.coordinator_designation}
            onChange={handleChange}
          >
            <MenuItem value="Principal">Principal</MenuItem>
            <MenuItem value="Vice Principal">Vice Principal</MenuItem>
          </Select>
        </FormControl> */}

        <TextField
          label="Admin Phone"
          name="user_phone"
          type="tel"
          value={editData.user_phone}
          onChange={handleChange}
          fullWidth
          margin="normal"
          inputProps={{ maxLength: 10 }}
        />

        <TextField
          label="Admin Email"
          name="user_email"
          type="email"
          value={editData.user_email}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Number of Students"
          name="number_of_students"
          value={editData.number_of_students}
          onChange={handleChange}
          fullWidth
          type="number"
          margin="normal"
        />

        {/* <div>Update School Image</div> */}
        {/* <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleFileChange}
          style={{ marginTop: "10px" }}
        />
        {selectedFile && (
          <div style={{ marginTop: "10px" }}>
            <img
              src={selectedFile}
              alt="Selected"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </div>
        )} */}

        {/* Update Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => onUpdate(editData)}
          style={{ marginTop: "20px", width: "100%" }}
        >
          Update
        </Button>

        {/* Close Button */}
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClose}
          style={{ marginTop: "10px", width: "100%" }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default EditSchool;
